package com.gsb.vyapar.bhagya.util

val emailRegex = "^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]+\$"
fun isValidEmail(email: String): Boolean {
    return email.matches(emailRegex.toRegex())
}

fun isEmailError(text: String): Boolean {
    return text.isNotEmpty() && !isValidEmail(text)
}

val passwordRegex = "^(?=.*[A-Z])(?=.*[a-z])(?=.*\\W).{8,}\$"
fun isValidPassword(password: String): Boolean {
    return password.matches(passwordRegex.toRegex())
}

fun isPasswordError(text: String): Boolean {
    return text.isNotEmpty() && !isValidPassword(text)
}

fun isValidUserIdPassword(userIdPassword: String): Boolean {
    return userIdPassword.length == 10
}

fun isUserIdPasswordError(text: String): Boolean {
    return text.isNotEmpty() && !isValidUserIdPassword(text)
}


fun isValidFirstName(firstName: String): Boolean {
    return firstName.length > 2
}

fun isFirstNameError(text: String): Boolean {
    return text.isNotEmpty() && !isValidFirstName(text)
}

fun isValidLastName(lastName: String): Boolean {
    return lastName.isNotEmpty()
}

fun isLastNameError(text: String): Boolean {
    return text.isNotEmpty() && !isValidLastName(text)
}

fun isValidBusinessName(businessName: String): Boolean {
    return businessName.length > 2
}

fun isBusinessNameError(text: String): Boolean {
    return text.isNotEmpty() && !isValidBusinessName(text)
}

fun isValidGotra(gotra: String): Boolean {
    return gotra.length > 2
}

fun isGotraError(text: String): Boolean {
    return text.isNotEmpty() && !isValidGotra(text)
}

fun isValidKuldev(kuldev: String): Boolean {
    return kuldev.length > 2
}

fun isKuldevError(text: String): Boolean {
    return text.isNotEmpty() && !isValidKuldev(text)
}

val mobileRegex = "^[6789]\\d{9}$"

fun isValidMobileNumber(mobileNumber: String): Boolean {
    return mobileNumber.length == 10 && mobileNumber.toDoubleOrNull() != null && mobileNumber.matches(mobileRegex.toRegex()) && !isSequentialPatterns(mobileNumber) && !(mobileNumber.all { it == mobileNumber[0] })
}

fun isMobileError(text: String): Boolean {
    return text.isNotEmpty() && !isValidMobileNumber(text)
}

fun isSequentialPatterns(mobileNumber: String): Boolean {
    val sequentialPatterns = listOf("1234567890", "9876543210")
    return sequentialPatterns.contains(mobileNumber)
}

fun isValidOtp(otp: String): Boolean {
    return otp.length == 6 && otp.toIntOrNull() != null
}

fun isOtpError(text: String): Boolean {
    return text.isNotEmpty() && !isValidOtp(text)
}

fun isValidPincode(pincode: String): Boolean {
    return pincode.length == 6 && pincode.toIntOrNull() != null
}

fun isPincodeError(text: String): Boolean {
    return text.isNotEmpty() && !isValidPincode(text)
}

val gstRegex = "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
fun isValidGst(gst: String): Boolean {
    return gst.matches(gstRegex.toRegex())
}

fun isGstError(text: String): Boolean {
    return text.isNotEmpty() && !isValidGst(text)
}

val adhaarRegex = "^\\d{12}$"
val panRegex = "^[A-Z]{5}[0-9]{4}[A-Z]$"
fun isValidAdhaarOrPan(aadharPan: String): Boolean {
    return aadharPan.matches(adhaarRegex.toRegex()) || aadharPan.matches(panRegex.toRegex())
}

fun isAdhaarOrPanError(text: String): Boolean {
    return text.isNotEmpty() && !isValidAdhaarOrPan(text)
}

fun isValidZipcode(zipcode: String): Boolean {
    return zipcode.length == 6
}

fun isZipcodeError(text: String): Boolean {
    return text.isNotEmpty() && !isValidZipcode(text)
}

fun isValidCity(city: String): Boolean {
    return city.length > 2
}

fun isCityError(text: String): Boolean {
    return text.isNotEmpty() && !isValidCity(text)
}

val fbRegex = "^(http:\\/\\/|https:\\/\\/)(www\\.)?facebook\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$"
fun isValidFb(fb: String): Boolean {
    return fb.matches(fbRegex.toRegex())
}

fun isFbError(text: String): Boolean {
    return text.isNotEmpty() && !isValidFb(text)
}

val instaRegex = "^(http:\\/\\/|https:\\/\\/)(www\\.)?instagram\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$"
fun isValidInsta(insta: String): Boolean {
    return insta.matches(instaRegex.toRegex())
}

fun isInstaError(text: String): Boolean {
    return text.isNotEmpty() && !isValidInsta(text)
}

val xRegex = "^(http:\\/\\/|https:\\/\\/)(www\\.)?x\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$"
fun isValidX(x: String): Boolean {
    return x.matches(xRegex.toRegex())
}

fun isXError(text: String): Boolean {
    return text.isNotEmpty() && !isValidX(text)
}

fun isValidDetail(detail: String): Boolean {
    return detail.length <= 4000
}

fun isDetailError(text: String): Boolean {
    return text.isNotEmpty() && !isValidDetail(text)
}

fun isValidAddress(address: String): Boolean {
    return address.length <= 320
}

fun isAddressError(text: String): Boolean {
    return text.isNotEmpty() && !isValidAddress(text)
}

val websiteRegex = "^(http:\\/\\/|https:\\/\\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$"
fun isValidWebsite(website: String): Boolean {
    return website.matches(websiteRegex.toRegex())
}

fun isWebsiteError(text: String): Boolean {
    return text.isNotEmpty() && !isValidWebsite(text)
}

val androidRegex = "^(http:\\/\\/|https:\\/\\/)(www\\.)?play\\.google\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$"
fun isValidAndroid(android: String): Boolean {
    return android.matches(androidRegex.toRegex())
}

fun isAndroidError(text: String): Boolean {
    return text.isNotEmpty() && !isValidAndroid(text)
}

val iosRegex = "^(http:\\/\\/|https:\\/\\/)(www\\.)?apps\\.apple\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$"
fun isValidIos(ios: String): Boolean {
    return ios.matches(iosRegex.toRegex())
}

fun isIosError(text: String): Boolean {
    return text.isNotEmpty() && !isValidIos(text)
}

val mqttUrlRegex = "^[a-zA-Z0-9.-]+\$"
fun isValidMqttUrl(mqttUrl: String): Boolean {
    return mqttUrl.matches(mqttUrlRegex.toRegex())
}

fun isMqttUrlError(text: String): Boolean {
    return text.isNotEmpty() && !isValidMqttUrl(text)
}

fun isValidPort(port: String): Boolean {
    return port.length == 4 && port.toIntOrNull() != null
}

fun isPortError(text: String): Boolean {
    return text.isNotEmpty() && !isValidPort(text)
}

fun isValidMqttUserName(mqttUserName: String): Boolean {
    return mqttUserName.isNotEmpty()
}

fun isMqttUserNameError(text: String): Boolean {
    return text.isNotEmpty() && !isValidMqttUserName(text)
}

fun isValidMqttPassword(mqttPassword: String): Boolean {
    return mqttPassword.isNotEmpty()
}

fun isMqttPasswordError(text: String): Boolean {
    return text.isNotEmpty() && !isValidMqttPassword(text)
}

fun isValidMqttCertificate(mqttCertificate: String): Boolean {
    return mqttCertificate.isNotEmpty()
}

fun isMqttCertificateError(text: String): Boolean {
    return text.isNotEmpty() && !isValidMqttCertificate(text)
}

val appVersionRegex = """\d+\.\d+\.\d+"""
fun isValidAppVersion(appVersion: String): Boolean {
    return appVersion.matches(appVersionRegex.toRegex())
}

fun isAppVersionError(text: String): Boolean {
    return text.isNotEmpty() && !isValidAppVersion(text)
}

fun isValidNumber(number: String): Boolean {
    return number != "0" && (number.isNotEmpty() && number.toIntOrNull() != null)
}

fun isNumberError(text: String): Boolean {
    return text.isNotEmpty() && !isValidNumber(text)
}

val latitudeRegex = """^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$"""
fun isValidLatitude(latitude: String): Boolean {
    return latitude.matches(latitudeRegex.toRegex())
}

fun isLatitudeError(text: String): Boolean {
    return text.isNotEmpty() && !isValidLatitude(text)
}

val longitudeRegex = """^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$"""
fun isValidLongitude(longitude: String): Boolean {
    return longitude.matches(longitudeRegex.toRegex())
}

fun isLongitudeError(text: String): Boolean {
    return text.isNotEmpty() && !isValidLongitude(text)
}

val youtubeRegex = "^(http:\\/\\/|https:\\/\\/)(www\\.)?youtube\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$"
fun isValidYoutube(youtube: String): Boolean {
    return youtube.matches(youtubeRegex.toRegex())
}

fun isYoutubeError(text: String): Boolean {
    return text.isNotEmpty() && !isValidYoutube(text)
}

val linkedInRegex = "^(http:\\/\\/|https:\\/\\/)(www\\.)?linkedin\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$"
fun isValidLinkkdIn(linkedIn: String): Boolean {
    return linkedIn.matches(linkedInRegex.toRegex())
}

fun isLinkedInError(text: String): Boolean {
    return text.isNotEmpty() && !isValidLinkkdIn(text)
}

val gMapsRegex = "^https:\\/\\/maps\\.app\\.goo\\.gl\\/[A-Za-z0-9]+$"
val gmapsFullRegex = "^https:\\/\\/(www\\.)?google\\.com\\/maps\\/(place|dir|search|@).*$"
fun isValidGMap(gmap: String): Boolean {
    return gmap.matches(gMapsRegex.toRegex()) || gmap.matches(gmapsFullRegex.toRegex())
}

fun isGMapError(text: String): Boolean {
    return text.isNotEmpty() && !isValidGMap(text)
}

fun isValidMobileUserId(mobileUserId: String): Boolean {
    return mobileUserId.length == 10 && mobileUserId.all { it.isLetter() }
}

fun isMobileUserIdError(text: String): Boolean {
    return text.isNotEmpty() && !isValidMobileUserId(text) && !isValidMobileNumber(text)
}
